import sha1 from '@/components/utils/sha1';

const transferPropertiesToComponent = (
  craftState: any,
  componentDataProperties: any,
  withSha1: boolean = false,
  isPage = false,
  isPageLayout = false,
) => {
  if (!componentDataProperties) return;
  if (!craftState) return;

  const rx = RegExp(/^(.*?)\[(.*?)\]$/);

  Object.keys(componentDataProperties).forEach((key: any) => {
    const matches = rx.exec(key);
    if (matches && matches.length === 3) {
      const nodeId = matches[2];
      const prop = matches[1];
      if (craftState[nodeId] && craftState[nodeId].props) {
        let changed = false;
        if (prop === 'className') {
          craftState[nodeId].props.className = componentDataProperties[key];
          if (componentDataProperties[key]) changed = true;
        } else if (prop === 'hide') {
          craftState[nodeId].props.hide = componentDataProperties[key];
          if (componentDataProperties[key]) changed = true;
        } else if (craftState[nodeId].props.properties) {
          //console.log(`craftState[${nodeId}]`, craftState[nodeId].type);
          craftState[nodeId].props.properties[prop] = componentDataProperties[key];
          if (isPage && (craftState[nodeId].type === 'ComponentData' || craftState[nodeId].type === 'ComponentRef')) {
            if (!craftState[nodeId].props.pov) craftState[nodeId].props.pov = {};
            craftState[nodeId].props.pov[`${prop}[ROOT]`] = componentDataProperties[key];
          } else if (
            isPageLayout &&
            (craftState[nodeId].type === 'ComponentData' || craftState[nodeId].type === 'ComponentRef')
          ) {
            if (!craftState[nodeId].props.plov) craftState[nodeId].props.plov = {};
            craftState[nodeId].props.plov[`${prop}[ROOT]`] = componentDataProperties[key];
          }
          if (componentDataProperties[key]) changed = true;
        }

        if (changed && withSha1) {
          try {
            const newKey = sha1(
              //@ts-ignore
              nodeId + JSON.stringify(componentDataProperties, Object.keys(componentDataProperties).sort()),
              'hex',
            );
            // TODO: Check if this is really needed
            // craftState[nodeId].changedKey = newKey;
          } catch (e) {}
        }
      }
    }
  });
};

export default transferPropertiesToComponent;
